module.exports = "//static.hsappstatic.net/academy-common-lib/static-1.13785/images/pngs/quiz_thumbnail.png"